import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { QuestionsService } from '../../services/questions.service';
import { Proposition, Question } from '../../interfaces/question.type';
import { ActivatedRoute } from '@angular/router';
import { core } from '@angular/compiler';
import { Quiz } from '../../interfaces/quiz.type';
import { CategoryQuizService } from '../../services/category-quiz.service';
import { CategoryQuestionService } from '../../services/category-question.service';
import { NiveauQuestionService } from '../../services/niveau-question.service';

@Component({
  selector: 'app-question-editor-import',
  templateUrl: './question-editor-import.component.html',
  styleUrls: ['./question-editor-import.component.scss'],
})
export class QuestionEditorImportComponent implements OnInit, OnChanges {
  @Input({ required: true }) question: Question;
  @Input({ required: true }) questionIndex!: number;
  @Input({ required: true }) trueData!: any[];

  allQuestions: any;
  editableLabel: boolean = false;
  correspondingQuiz: Quiz;
  editableTheme: boolean = false;
  initAnswerMode: Proposition;
  id: string;
  categoryList: any;
  levelList: any;
  currentLevel: any;
  selectedCategory: any;

  constructor(
    private questions: QuestionsService,
    private router: ActivatedRoute,
    private category: CategoryQuestionService,
    private niveauQuestion: NiveauQuestionService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question']) {
      // Actualiser le theme a chaque update question

      if (typeof this.question?.theme !== 'object') {
        if (this.trueData.length > 0) {
          this.question.theme = this.trueData[this.trueData.length - 1].theme;

          // console.log(
          //   'TRUE DATA EST DEFINIE',
          //   this.trueData,
          //   this.question,
          //   this.question.theme,
          //   'LENGTH DATA -1',
          //   this.trueData[this.trueData.length - 1]
          // );
        } else {
          this.category.getAllQuestionCategories().subscribe({
            next: (data) => {
              this.categoryList = data;

              this.question.theme =
                data[Math.floor(Math.random() * data.length)];
              console.log(
                'TRUE DATA EST PAS DEFINIE',
                this.trueData,
                this.question,
                this.question?.theme,
                'LENGTH DATA -1',
                this.trueData[this.trueData.length - 1]
              );

              console.log('les categories disponible :', data);
            },
          });
        }

        // this.category.getAllQuestionCategories().subscribe({
        //   next: (data) => {
        //     this.categoryList = data;
        //     // this.question.theme = data[Math.floor(Math.random() * data.length)];
        //     if (this.trueData.length > 0) {
        //       this.question.theme =
        //         this.trueData[this.trueData.length - 1].theme;

        //       console.log(
        //         'TRUE DATA EST DEFINIE',
        //         this.trueData,
        //         this.question,
        //         this.question.theme,
        //         'LENGTH DATA -1',
        //         this.trueData[this.trueData.length - 1]
        //       );
        //     } else {
        //       this.question.theme =
        //         data[Math.floor(Math.random() * data.length)];
        //       console.log(
        //         'TRUE DATA EST PAS DEFINIE',
        //         this.trueData,
        //         this.question,
        //         this.question.theme,
        //         'LENGTH DATA -1',
        //         this.trueData[this.trueData.length - 1]
        //       );
        //     }
        //     console.log('les categories disponible :', data);
        //   },
        // });
      } else {
        console.log('theme deja definie');
      }

      if (this.trueData.length > 0) {
        // this.question.difficulte = this.currentLevel.niveauquestionid;
        // console.log('niveau disponible :', data.sort());
        // console.log('niveau disponible' ,this.trueData , this.trueData[this.trueData.length - 1].difficulte);

        this.question.difficulte =
          this.trueData[this.trueData.length - 1].difficulte;
        console.log(
          'Assignation du dernier niveau de quiz',
          this.trueData,
          this.trueData[this.trueData.length - 1].difficulte
        );
      } else {
        this.niveauQuestion.getAllLevels().subscribe({
          next: (data) => {
            this.levelList = data.sort();
            console.log('le niveau a bien ete chargée : ', data);
            this.currentLevel = data[Math.floor(Math.random() * data.length)];
            this.question.difficulte = this.currentLevel.niveauquestionid;
            console.log('niveau disponible :', data.sort());
          },
        });
      }

      // this.niveauQuestion.getAllLevels().subscribe({
      //   next: (data) => {
      //     this.levelList = data.sort();
      //     console.log('le niveau a bien ete chargée : ', data);
      //     this.currentLevel = data[Math.floor(Math.random() * data.length)];
      //     if (this.trueData.length < 1) {
      //       this.question.difficulte = this.currentLevel.niveauquestionid;
      //       console.log('niveau disponible :', data.sort());
      //     } else {
      //       this.question.difficulte =
      //         this.trueData[this.trueData.length - 1].difficulte;
      //       console.log(
      //         'Assignation du dernier niveau de quiz',
      //         this.trueData,
      //         this.trueData[this.trueData.length - 1].difficulte
      //       );
      //     }
      //   },
      // });
    }
  }

  ngOnInit(): void {
    this.id = this.router.snapshot.paramMap.get('id');
    let urlIdData = JSON.parse(this.router.snapshot.paramMap.get('data'));
    console.log('Question courante: ', this.question);

    this.niveauQuestion.getAllLevels().subscribe({
      next: (data: any[]) => {
            console.log('Question courante: ', this.question);

        this.levelList = data.sort();

                    console.log('levelList courante: ', this.levelList);
                    console.log('trueData courante: ', this.trueData);


        if (this.trueData.length < 1) {

          this.currentLevel = data[Math.floor(Math.random() * data.length)];
          this.question.difficulte = this.currentLevel.niveauquestionid;
          console.log('niveau disponible :', this.question.difficulte);
        } else {
          this.currentLevel = data.filter(
            (level) =>
              level.niveauquestionid ==
              this.trueData[this.trueData.length - 1].difficulte

          );

          this.question.difficulte =
            this.trueData[this.trueData.length - 1].difficulte;
          console.log(
            'Assignation du dernier niveau de quiz=========',
            this.trueData,
            this.trueData[this.trueData.length - 1].difficulte
          );
        }
        console.log('Niveau choisit aleatoirement :', this.currentLevel);
      },
    });

    this.category.getAllQuestionCategories().subscribe({
      next: (data) => {
        this.categoryList = data;
        this.question.theme = data[Math.floor(Math.random() * data.length)];
        console.log('les categories disponible :', data);
      },
    });

    console.log('Nouvelle données et page charger ...');

    this.question.nbreReponse = this.question?.proposition?.filter(
      (reponse) => reponse.isCorrect === true
    )?.length;

    if (this.question?.proposition?.length === 2) {
      this.question.typeReponse = 'Binaire';
    } else {
      this.question.typeReponse = 'Multiple';
    }
  }

  toggleEditQuestionLabel() {
    this.editableLabel = !this.editableLabel;
  }

  toggleEditQuestionTheme() {
    this.editableTheme = !this.editableTheme;
  }

  changeQuestionLevel(level: any) {
    this.currentLevel = level;
    this.question.difficulte = this.currentLevel.niveauquestionid;
    console.log('le current level state: ', this.currentLevel, 'difficuleter level',this.question.difficulte) ;
  }

  // descreaseDifficulty() {
  //   let b = this.findClosestDifficulty(
  //     this.levelList,
  //     this.currentLevel.pointdifficulte - 1
  //   );

  //   console.log(b);
  // }

  // findClosestDifficulty(allLevels: any[], target: number): number {
  //   let numbers = allLevels.map((niveau) => niveau.pointdifficulte);
  //   let closestNumber = numbers[0];
  //   let closestDistance = Math.abs(numbers[0] - target);

  //   for (let i = 1; i < numbers.length; i++) {
  //     const distance = Math.abs(numbers[i] - target);
  //     if (distance < closestDistance) {
  //       closestNumber = numbers[i];
  //       closestDistance = distance;
  //     }
  //   }
  //   console.log(closestNumber);

  //   this.currentLevel = allLevels.filter(
  //     (level) => level.pointdifficulte === closestNumber
  //   )[0];
  //   this.question.difficulte = this.currentLevel.niveauquestionid;

  //   this.question.niveauquestion = this.currentLevel;
  //   console.log(this.currentLevel);
  //   return closestNumber;
  // }

  // increaseDifficulty() {
  //   // if (this.question.difficulte < 3) {
  //   //   this.question.difficulte += 1;
  //   //   console.log('Upm difficulty : ', this.question);
  //   // }
  //   let b = this.findClosestDifficulty(
  //     this.levelList,
  //     this.currentLevel.pointdifficulte + 1
  //   );

  //   this.question.difficulte = this.currentLevel.niveauquestionid;

  //   console.log(b);
  // }

  // difficultyStatus(id: number): string {
  //   let status: string;
  //   switch (id) {
  //     case 1:
  //       status = 'Facile';
  //       break;
  //     case 2:
  //       status = 'Moyen';
  //       break;
  //     case 3:
  //       status = 'Difficile';
  //       break;

  //     default:
  //       break;
  //   }

  //   return status;
  // }

  toggleAnswerMode($event: any) {
    try {
      console.log('Mode actuel : ', $event);
      if ($event == 'Binaire') {
        this.question.proposition = [
          {
            title: 'Vrai',
            isCorrect: true,
            code: null,
          },
          {
            title: 'Faux',
            isCorrect: false,
            code: null,
          },
        ];
        console.log('deux champs', $event);
      } else {
        console.log('4 champs', $event);
        this.question.proposition = [
          {
            title: '',
            isCorrect: true,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
          {
            title: '',
            isCorrect: false,
            code: null,
          },
        ];
      }
    } catch (error) {
      console.log(error, $event);
    }
  }

  onCategoryChange($value: any) {
    console.log('Selected category:', $value);
    this.question.theme = $value;
  }

  selectCorrectAnswer(
    proposition: Proposition,
    clickedPropositionIndex: number
  ) {
    console.log('Proposition : ', this.question);

    const propositionIndex = this.question.proposition.indexOf(proposition);

    if (this.question.typeReponse === 'Multiple') {
      if (propositionIndex !== -1) {
        this.question.proposition[propositionIndex] = {
          ...proposition,
          isCorrect: !proposition.isCorrect,
        };
      }
    } else {
      console.log('Le type de reponse est binaire');
      this.question.proposition = this.question.proposition.map(
        (proposition, index) => {
          if (index === clickedPropositionIndex) {
            // Si la proposition cliquée est déjà marquée comme correcte,
            // on la marque comme fausse, et vice versa.
            return {
              ...proposition,
              isCorrect: !proposition.isCorrect,
            };
          } else {
            // Si une autre proposition est marquée comme correcte,
            // on la marque comme fausse.
            return {
              ...proposition,
              isCorrect: false,
            };
          }
        }
      );

      console.log(
        'Hello',
        this.question.proposition.map((proposition, index) => {
          if (proposition.isCorrect) {
            return {
              ...proposition,
              isCorrect: false,
            };
          } else {
            return {
              ...proposition,
              isCorrect: true,
            };
          }
        })
      );
    }

    this.question.nbreReponse = this.question.proposition.filter(
      (reponse) => reponse.isCorrect === true
    ).length;
  }

  // logges les infos a propos de la difficultée:: Debug
  logLevelInfo() {
    console.log(this.question, this.trueData);
  }
}
